





















































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { ChatbotMsg } from '../models/ChatbotMsg';
import { ColorsList } from '../../core/utils';
import { botMsgColor } from '../utils'
import LoadingIndicator from '../../core/components/LoadingIndicator.vue';
import { MessageType } from '../models/ChatConstants';
import RenderMarkdown from '../../core/components/RenderMarkdown.vue';
import ChatbotMessageActions from './ChatbotMessageActions.vue';
@Component({
    components: {
      LoadingIndicator,
      RenderMarkdown,
      ChatbotMessageActions
    }
})
export default class ChatbotMessage extends Vue {
  @Prop({default: ''}) message: ChatbotMsg; 
  userBg: string = ColorsList.dark_smartway;
  botBg: string = botMsgColor;

  get messageIsFromBot(): boolean{
    return this.message.message_type == MessageType.BOT
  }

  get messageIsPending(): boolean{
    return this.messageIsFromBot && this.message.message == ''
  }

  get shouldRenderMessageActions(): boolean{
    return this.messageIsFromBot && this.message.id !== -1 && !this.messageIsPending
  }

  get getCardColor(): string{
    if(this.message.hasOwnProperty('error')){
      return ColorsList.red_pastel
    }
    if(this.messageIsFromBot){
      return this.botBg
    }

    return this.userBg
  }

  @Emit()
  tryAgain(){}
   
}
